export default __webpack_public_path__ + "static/media/icone-sucesso.564430bb.png";